// Константы для редактора счетов

export const SEARCH_DEBOUNCE_MS = 2000;
export const API_TIMEOUT_MS = 5000;
export const REFRESH_DELAY_MS = 100;

export const IFRAME_ACTIONS = {
  DISPLAY_DATA: 'DISPLAY_DATA',
  SEARCH_COUNTERPARTIES: 'SEARCH_COUNTERPARTIES',
  GET_ACCOUNT_DATA: 'GET_ACCOUNT_DATA',
  ACCOUNT_DATA_RESPONSE: 'ACCOUNT_DATA_RESPONSE',
  ACCOUNT_DATA_UPDATED: 'ACCOUNT_DATA_UPDATED',
  DELETE_DATE: 'DELETE_DATE',
  DELETE_SUBACCOUNT: 'DELETE_SUBACCOUNT',
  ADD_COUNTERPARTY: 'ADD_COUNTERPARTY',
  DELETE_COUNTERPARTY: 'DELETE_COUNTERPARTY',
  ADD_SUBACCOUNT: 'ADD_SUBACCOUNT',
  DELETE_ACCOUNT: 'DELETE_ACCOUNT'
};

export const REDUX_ACTION_TYPES = {
  LOAD_REQUEST_START: 'LOAD_REQUEST_START',
  LOAD_REQUEST_SUCCESS: 'LOAD_REQUEST_SUCCESS',
  LOAD_REQUEST_FAIL: 'LOAD_REQUEST_FAIL'
};

export const MONTHS = [
  { value: 1, label: 'Январь' },
  { value: 2, label: 'Февраль' },
  { value: 3, label: 'Март' },
  { value: 4, label: 'Апрель' },
  { value: 5, label: 'Май' },
  { value: 6, label: 'Июнь' },
  { value: 7, label: 'Июль' },
  { value: 8, label: 'Август' },
  { value: 9, label: 'Сентябрь' },
  { value: 10, label: 'Октябрь' },
  { value: 11, label: 'Ноябрь' },
  { value: 12, label: 'Декабрь' }
];

export const YEAR_RANGE = 10; // диапазон лет для выбора
export const YEARS_BACK_FROM_CURRENT = 5; // на сколько лет назад от текущего года